import {ToggleButton, ToggleButtonGroup} from '@mui/material';
import {styled} from '@mui/styles';
import React from 'react';

const Container = styled('div')(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  padding: theme.spacing(2),

  '& > span': {
    flex: 1,
    padding: theme.spacing(0, 2, 0, 0)
  },

  '& .MuiToggleButton-root': {
    '&.yes': {
      color: theme.palette.success.main,
      '&.Mui-selected': {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.success.contrastText,
      },
    },

    '&.no': {
      color: theme.palette.error.main,
      '&.Mui-selected': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
      }
    }
  },

  '&.small': {
    padding: 0,
  }
}));

const YesNoSwitch = ({checked, setChecked, label, small = false}) => (
  <Container {...(small ? {className: 'small'} : {})}>
    <span>{label}</span>
    <ToggleButtonGroup
      value={checked}
      exclusive
      onChange={(e, updated) => setChecked(updated)}
      size={small ? 'small' : 'medium'}
    >
      <ToggleButton className="yes" value={true}>Yes</ToggleButton>
      <ToggleButton className="no" value={false}>No</ToggleButton>
    </ToggleButtonGroup>
  </Container>
);

export default YesNoSwitch;
